module.exports = __webpack_public_path__ + "static/img/云平台-en.98eecb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/云平台-en.png
// module id = 3iCH
// module chunks = 1